/* unplugin-vue-components disabled */import { render } from "./LatestComponent.vue?vue&type=template&id=4b10744e&scoped=true"
import script from "./LatestComponent.vue?vue&type=script&lang=js"
export * from "./LatestComponent.vue?vue&type=script&lang=js"

import "./LatestComponent.vue?vue&type=style&index=0&id=4b10744e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b10744e"]])

export default __exports__